import Grid, { GridProps } from "@material-ui/core/Grid";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import backgroundImage from "assets/login-image.svg";
import { backgroundImageStyle, breakpoints, color } from "style/constants";

type StyledGridProps = GridProps;

export const ImageOverlay = styled.div`
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8));
  height: 25%;
  position: relative;
  top: 75%;
` as React.FC;

export const StyledLeftGrid = styled(({ ...otherProps }) => <Grid {...otherProps} />)`
  && {
    @media (max-width: ${breakpoints.lg - 1}px) {
      display: none;
    }
    ${backgroundImageStyle(backgroundImage)}
    position: relative;
  }
` as React.FC<StyledGridProps>;

export const StyledRightGrid = styled(({ ...otherProps }) => <Grid {...otherProps} />)`
  && {
    @media (max-width: ${breakpoints.lg}px) {
      margin: auto;
      padding-bottom: 33px;
      padding-left: 50px;
      padding-right: 50px;
      padding-top: 80px;
    }
    // padding-left: 80px;
    // padding-right: 80px;
    padding-top: 60px;
    max-width: 533px;
    img {
    }
  }
` as React.FC<StyledGridProps>;

export const StyledForm = styled(({ ...otherProps }) => <Grid {...otherProps} />)`
  && {
    @media (max-width: ${breakpoints.md}px) {
      width: initial;
      margin: 0;
      padding-left: 0;
      float: unset;
    }
    width: 75%;
    margin: auto;
    float: left;
    padding-left: 30%;
  }
` as React.FC<StyledGridProps>;

export const StyledMainGrid = styled(({ ...otherProps }) => <Grid {...otherProps} />)`
  && {
    height: 100%;
    background-color: #fff;
  }
` as React.FC<StyledGridProps>;

export const LoginCallout = styled.p`
  @media (max-width: ${breakpoints.lg}px) {
    text-align: center;
  }
  color: ${color.DARKERGRAY};
  font-size: 0.875rem;
  line-height: 1.375rem;
`;

export const Title = styled.h1`
  @media (max-width: ${breakpoints.lg}px) {
    font-size: 1.875rem;
    text-align: center;
  }
  color: ${color.BLACK};
  font-family: Mercury Display;
  font-size: 2.25rem;
  font-weight: normal;
  line-height: 2.5625rem;
`;

export const StyledForgotPasswordLink = styled(Link)`
  color: ${color.DARKERGRAY};
  font-size: 12px;
`;

export const Image = styled.img`
  height: 100px;
  width: 230px;
  margin-left: 30px;
  margin-bottom: 30px;
  @media (max-width: ${breakpoints.lg}px) {
    height: 65px;
    margin-left: 0;
  }
`;
